import { Stack, InputLabel, MenuItem } from '@compass/core';
import { FormControl, Select, SelectChangeEvent } from '@mui/material';
import { useSchoolEnrollmentData } from '../contexts/SchoolEnrollmentDataContext';

export const SchoolEnrollmentFilterControls = () => {
    const { 
        filter, 
        updateFilter, 
        activeSchoolYear, 
        schoolYears 
    } = useSchoolEnrollmentData();

    const displayedYear = filter.schoolYear ?? activeSchoolYear ?? '';

    const handleYearChange = (event: SelectChangeEvent<number | string>) => {
        updateFilter({ schoolYear: Number(event.target.value) });
    };

    if (schoolYears.length === 0) {
        return null;
    }

    return (
        <Stack direction="row" spacing="sm" sx={{ mb: 2 }}>
            <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel id="school-enrollment-year-label">School Year</InputLabel>
                <Select
                    labelId="school-enrollment-year-label"
                    value={displayedYear}
                    label="School Year"
                    onChange={handleYearChange}
                >
                    {schoolYears.map(year => (
                        <MenuItem key={year} value={year}>
                            {`${year}-${year + 1}`}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Stack>
    );
};